<template>
  <aside :class="['bf-sidebar', { open: stateStoreInstance.open }]">
    <!-- Logo -->
    <div class="bf-sidebar__logo">
      <router-link to="/" class="d-flex align-center">
        <img :src="logoSrc" alt="Bindfy" />
      </router-link>
    </div>

    <!-- Navegacao -->
    <nav class="bf-sidebar__nav">
      <div class="bf-sidebar__label">MENU</div>

      <router-link to="/" class="bf-nav-item" exact-active-class="is-active">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="9" rx="1.5"></rect><rect x="14" y="3" width="7" height="5" rx="1.5"></rect><rect x="14" y="12" width="7" height="9" rx="1.5"></rect><rect x="3" y="16" width="7" height="5" rx="1.5"></rect></svg>
        Dashboard
      </router-link>

      <!-- Conectores (grupo) -->
      <div class="bf-nav-item" :class="{ 'is-open': openConnectors }" @click="togglConnectors">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M9 6h11M9 12h11M9 18h11"></path><circle cx="4.5" cy="6" r="1.6"></circle><circle cx="4.5" cy="12" r="1.6"></circle><circle cx="4.5" cy="18" r="1.6"></circle></svg>
        Conectores
        <svg class="bf-nav-item__caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"></path></svg>
      </div>
      <div v-if="openConnectors" class="bf-nav-sub">
        <router-link to="/conectores/entrada" class="bf-nav-subitem" active-class="is-active">Entrada</router-link>
        <router-link to="/conectores/saida" class="bf-nav-subitem" active-class="is-active">Saída</router-link>
      </div>

      <router-link to="/queries" class="bf-nav-item" active-class="is-active">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M4 17l6-6-6-6"></path><path d="M12 19h8"></path></svg>
        Queries
      </router-link>

      <router-link to="/integracoes" class="bf-nav-item" active-class="is-active">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="5" cy="12" r="2.5"></circle><circle cx="19" cy="5" r="2.5"></circle><circle cx="19" cy="19" r="2.5"></circle><path d="M7.3 10.8L16.7 6.2M7.3 13.2l9.4 4.6"></path></svg>
        Integrações
      </router-link>

      <router-link to="/execucoes" class="bf-nav-item" active-class="is-active">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><path d="M12 7v5l3.5 2"></path></svg>
        Histórico
      </router-link>

      <!-- Pagamentos (grupo) -->
      <div class="bf-nav-item" :class="{ 'is-open': openPayments }" @click="togglPayments">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2.5" y="5" width="19" height="14" rx="2.5"></rect><path d="M2.5 10h19"></path></svg>
        Pagamentos
        <svg class="bf-nav-item__caret" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M6 9l6 6 6-6"></path></svg>
      </div>
      <div v-if="openPayments" class="bf-nav-sub">
        <router-link to="/pagamentos/assinaturas" class="bf-nav-subitem" active-class="is-active">Assinatura</router-link>
        <router-link to="/pagamentos/historico" class="bf-nav-subitem" active-class="is-active">Histórico de faturas</router-link>
      </div>

      <router-link to="/usuarios" class="bf-nav-item" active-class="is-active">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="4"></circle><path d="M4.5 20.5c1.5-3.5 4.2-5 7.5-5s6 1.5 7.5 5"></path></svg>
        Usuários
      </router-link>

      <router-link to="/configuracoes/notificacoes" class="bf-nav-item" active-class="is-active">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 9-3 9h18s-3-2-3-9"></path><path d="M13.73 21a2 2 0 0 1-3.46 0"></path></svg>
        Notificações
      </router-link>

      <router-link to="/ticket" class="bf-nav-item" active-class="is-active">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="9"></circle><path d="M9.2 9a2.8 2.8 0 1 1 3.6 2.7c-.7.3-.8.8-.8 1.8"></path><circle cx="12" cy="17" r=".5" fill="currentColor"></circle></svg>
        Suporte
      </router-link>
    </nav>

    <!-- Rodape: toggle de tema + usuario -->
    <div class="bf-sidebar__footer">
      <div class="bf-theme-toggle" @click="toggleTheme">
        <span>{{ isDark ? "Modo escuro" : "Modo claro" }}</span>
        <div class="bf-switch" :class="{ on: isDark }">
          <div class="bf-switch__knob"></div>
        </div>
      </div>

      <div class="bf-user">
        <div class="bf-user__avatar">{{ userInitials }}</div>
        <div class="bf-user__info">
          <div class="bf-user__name">{{ userName }}</div>
          <div class="bf-user__role">{{ userRole }}</div>
        </div>
        <svg class="bf-user__logout" @click="handleLogout" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" title="Sair"><path d="M15 4h4v16h-4M10 17l5-5-5-5M15 12H3"></path></svg>
      </div>
    </div>
  </aside>
</template>

<script lang="ts">
import { defineComponent, computed, ref, onMounted } from "vue";

import stateStore from "@/utils/store";
import router from "@/router";

import { useAuthStore } from "@/stores/auth.store";
import { useAuth } from "@/composables/useAuth";
import { useAppTheme } from "@/composables/useTheme";

import logoPurple from "@/assets/img/brand/bindfy_logo_new_purple.png";
import logoWhite from "@/assets/img/brand/bindfy_logo_new_white.png";

export default defineComponent({
  name: "MainSidebar",
  setup() {
    const stateStoreInstance = stateStore;
    const authStore = useAuthStore();
    const { logout } = useAuth();
    const { isDark, toggleTheme, syncBody } = useAppTheme();

    onMounted(() => syncBody());

    const logoSrc = computed(() => (isDark.value ? logoWhite : logoPurple));

    const user = computed<any>(() => authStore.getUser);
    const userName = computed(
      () => user.value?.name || user.value?.login || "Usuário"
    );
    const userRole = computed(() =>
      user.value?.admin ? "Administrador" : "Usuário"
    );
    const userInitials = computed(() => {
      const src = String(userName.value || "U").trim();
      const parts = src.split(/\s+/);
      const first = parts[0]?.[0] || "U";
      const last = parts.length > 1 ? parts[parts.length - 1][0] : "";
      return (first + last).toUpperCase();
    });

    const openConnectors = ref(false);
    const openPayments = ref(false);
    const togglConnectors = () => (openConnectors.value = !openConnectors.value);
    const togglPayments = () => (openPayments.value = !openPayments.value);

    const handleLogout = async () => {
      try {
        await logout();
      } finally {
        authStore.setLogout();
        router.push({ name: "SignInPage" });
      }
    };

    return {
      stateStoreInstance,
      logoSrc,
      isDark,
      toggleTheme,
      userName,
      userRole,
      userInitials,
      openConnectors,
      openPayments,
      togglConnectors,
      togglPayments,
      handleLogout,
    };
  },
});
</script>

<style lang="scss" scoped>
.bf-sidebar {
  width: 248px;
  flex: none;
  background: var(--surface);
  border-right: 1px solid var(--border);
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  height: 100vh;
  z-index: 222;
  box-sizing: border-box;
  transition: transform 0.25s ease;
}

.bf-sidebar__logo {
  padding: 26px 20px 20px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    height: 72px;
    width: auto;
    max-width: 100%;
    display: block;
  }
}

.bf-sidebar__nav {
  padding: 8px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  overflow-y: auto;
  flex: 1;
}

.bf-sidebar__label {
  font-size: 10.5px;
  font-weight: 700;
  letter-spacing: 0.12em;
  color: var(--text3);
  padding: 8px 12px 6px;
}

.bf-nav-item {
  display: flex;
  align-items: center;
  gap: 11px;
  padding: 10px 12px;
  border-radius: 10px;
  cursor: pointer;
  font-size: 13.5px;
  font-weight: 600;
  color: var(--text2);
  text-decoration: none;
  transition: background 0.15s ease, color 0.15s ease;

  svg {
    width: 17px;
    height: 17px;
    flex: none;
  }

  &:hover {
    background: var(--hover);
    color: var(--text);
  }

  &.is-active {
    background: var(--chip-bg);
    color: var(--chip-fg);
    font-weight: 700;
  }

  &__caret {
    margin-left: auto;
    width: 13px !important;
    height: 13px !important;
    transition: transform 0.2s ease;
  }
  &.is-open &__caret {
    transform: rotate(180deg);
  }
}

.bf-nav-sub {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 2px 0 2px 30px;
}

.bf-nav-subitem {
  padding: 8px 12px;
  border-radius: 9px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text2);
  text-decoration: none;
  transition: background 0.15s ease, color 0.15s ease;

  &:hover {
    background: var(--hover);
    color: var(--text);
  }
  &.is-active {
    color: var(--chip-fg);
    background: var(--chip-bg);
  }
}

.bf-sidebar__footer {
  margin-top: auto;
  padding: 14px 16px;
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.bf-theme-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 9px 12px;
  border-radius: 10px;
  border: 1px solid var(--border);
  cursor: pointer;
  background: var(--surface2);

  span {
    font-size: 12.5px;
    font-weight: 600;
    color: var(--text2);
  }
  &:hover {
    border-color: var(--brand2);
  }
}

.bf-switch {
  width: 34px;
  height: 19px;
  border-radius: 10px;
  background: var(--mut-bg);
  position: relative;
  transition: background 0.2s;
  flex: none;

  &.on {
    background: var(--brand2);
  }
  &__knob {
    position: absolute;
    top: 2.5px;
    left: 2.5px;
    width: 14px;
    height: 14px;
    border-radius: 50%;
    background: #fff;
    transition: left 0.2s;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.25);
  }
  &.on &__knob {
    left: 17.5px;
  }
}

.bf-user {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 4px 2px;

  &__avatar {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    flex: none;
    background: linear-gradient(150deg, var(--brand-deep), var(--brand2));
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12.5px;
    font-weight: 700;
  }
  &__info {
    min-width: 0;
  }
  &__name {
    font-size: 12.5px;
    font-weight: 700;
    line-height: 1.2;
    color: var(--text);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__role {
    font-size: 11px;
    color: var(--text3);
  }
  &__logout {
    margin-left: auto;
    width: 15px;
    height: 15px;
    color: var(--text3);
    cursor: pointer;
    flex: none;
    &:hover {
      color: var(--err-fg);
    }
  }
}

/* Mobile: off-canvas */
@media only screen and (max-width: 991px) {
  .bf-sidebar {
    transform: translateX(-100%);
  }
  .bf-sidebar.open {
    transform: translateX(0);
    box-shadow: var(--shadow);
  }
}
</style>
